import { ValidatorRequiredIfBool, ValidatorRequiredIfOtherFieldNotEquals, ValidatorRequiredNotEmptyIfBool, ValidatorRequiredNotEmptyIfFalse } from 'src/app/helpers/validators';
import { CreateEmployeePatientModel, InsuranceProviderModel } from './../../../models/medClinicModels';
import { createReducer, on, Action } from '@ngrx/store';
import { loadMedClinicPatients, loadMedClinicPatientsSuccess, saveMedClinicPatient, saveMedClinicPatientSuccess, saveMedClinicPatientFailure, updateCreatePatientForm, loadInsuranceProvidersSuccess, checkForDuplicateMedClinicPatient, checkForDuplicateMedClinicPatientSuccess, checkForDuplicateMedClinicPatientFailure } from './medclinic.actions';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

export interface MedClinicState {
  patientsList: CreateEmployeePatientModel[];
  loadingPatients: boolean;
  savingPatients: boolean;
  disableForm: boolean;
  patient: CreateEmployeePatientModel;
  insuranceProviders: InsuranceProviderModel[];
}

const initialState: MedClinicState = {
  patientsList: null,
  loadingPatients: false,
  savingPatients: false,
  disableForm: false,
  patient: null,
  insuranceProviders: null
};

export const medClinicStateReducer = createReducer(initialState,
  on(loadMedClinicPatients, (state, action) => {
    return {
      ...state,
      loadingPatients: true
    };
  }),
  on(loadMedClinicPatientsSuccess, (state, action) => {
    return {
      ...state,
      patientsList: action.patients,
      loadingPatients: false
    };
  }),

  on(saveMedClinicPatient, (state, action) => {
    return {
      ...state,
      savingPatients: true,
      disableForm: true
    };
  }),
  on(saveMedClinicPatientSuccess, (state, action) => {
    return {
      ...state,
      savingPatients: false,
      disableForm: false
    };
  }),

  on(saveMedClinicPatientFailure, (state, action) => {
    return {
      ...state,
      savingPatients: false,
      disableForm: false
    };
  }),

  on(checkForDuplicateMedClinicPatient, (state, action) => {
    return {
      ...state,
      savingPatients: true,
      disableForm: true
    };
  }),
  on(checkForDuplicateMedClinicPatientSuccess, (state, action) => {
    return {
      ...state,
      savingPatients: false
    };
  }),
  on(checkForDuplicateMedClinicPatientFailure, (state, action) => {
    return {
      ...state,
      savingPatients: false,
      disableForm: false
    };
  }),

  on(updateCreatePatientForm, (state, action) => {
    const newState = { ...state, ...{ patient: action.patientValues, formErrors: action.formErrors } };
    return newState;
  }),

  on(loadInsuranceProvidersSuccess, (state, action) => {
    return {
      ...state,
      insuranceProviders: action.insuranceProviders,
    };
  }),

);

export function medClinicStateReducerFunc(state: MedClinicState | undefined, action: Action) {
  return medClinicStateReducer(state, action);
}


export function initCreatePatientForm(email: string) {
  const form = new UntypedFormGroup({
    firstName: new UntypedFormControl(null, [Validators.maxLength(255)]),
    middleName: new UntypedFormControl(null, [Validators.maxLength(255)]),
    lastName: new UntypedFormControl(null, [Validators.maxLength(255)]),
    relationshipToClient: new UntypedFormControl(null, [Validators.required]),
    birthdate: new UntypedFormControl(null, []),
    gender: new UntypedFormControl(null, []),
    reasonForInquiry: new UntypedFormControl(null, [Validators.required]),
    email: new UntypedFormControl(email, [Validators.required, Validators.email]),
    insuranceProviderID: new UntypedFormControl(null, []),
    memberID: new UntypedFormControl(null, []),
    policyNumber: new UntypedFormControl(null, []),
    policyHolderFirstName: new UntypedFormControl(null, []),
    policyHolderLastName: new UntypedFormControl(null, []),
    policyHolderDoB: new UntypedFormControl(null, []),
    startDate: new UntypedFormControl(null, []),
    expirationDate: new UntypedFormControl(null, []),
    isMedClinic: new UntypedFormControl(null, []),
    isPsychMed: new UntypedFormControl(null, []),
  }, [ValidatorRequiredIfOtherFieldNotEquals(['firstName', 'lastName', 'birthdate', 'gender'], 'relationshipToClient', 'Self'),
ValidatorRequiredIfOtherFieldNotEquals(['policyHolderFirstName', 'policyHolderLastName', 'policyHolderDoB','startDate'], 'insuranceProviderID', null)
  ]);



  return form;
}

